import { decodeStorage } from 'functions/storageBase64';
import { useEffect , useState } from 'react';
import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import useCartLocal from './useCartLocal';
import useCartServer from './useCartServer';

const useCartsUser = () => {

    const { 
        serverListCarts, 
        respServerList,
        serverCreateCart,
        respCreateCartS,
        serverAddProducts,
        respAddProductS,
        serverDeleteProducts,
        respDeleteProductS,
        setLastEventsS
    } = useCartServer()

    const { 
        localListCarts, 
        respLocalList,
        localCreateCart,
        respCreateCartL,
        localAddProducts,
        respAddProductL,
        localDeleteProducts,
        respDeleteProductL,
        setLastEventsL
    } = useCartLocal()

    
    const [, dispatch] = useStore((state) => state.giftTable.giftTable);
    const userProfile = decodeStorage('profileData')
    const idSears = userProfile ? String(userProfile?.idClaro) : null
    const [ responseListEvents, setResponseListEvents ] = useState(false)
    const [ productsList, setProductsList ] = useState(false)
    const [ listEvents, setListEvents ] = useState(false)
    const [ firstAdd, setFirstAdd ] = useState(false)
    const [ addProducts, setAddProducts ] = useState(false)


    // va por los datos del Carrito
    const getListCarts = async (eventID) => {
        const event_id = String(eventID)

        if(idSears){
            serverListCarts(idSears, event_id)
        }else{
            localListCarts(event_id)
        }
    }
    useEffect(()=>{
        if(respServerList){
            setResponseListEvents(respServerList)
        }else if(respLocalList){
            setResponseListEvents(respLocalList)
        }
    },[ respServerList, respLocalList ])



    // crea el carrito con el post
    const createCartEvent = async (eventID, payload) => {
        const event_id = String(eventID)
        
        if(idSears){
            serverCreateCart( event_id, payload )
        }else{
            localCreateCart( event_id, payload )
        }
    }
    useEffect(()=>{
        if(respCreateCartS){
            setResponseListEvents(respCreateCartS)
        }else if(respCreateCartL){
            setResponseListEvents(respCreateCartL)
        }
    },[ respCreateCartS, respCreateCartL ])



    // agrega productos con el patch
    const addProductEvent = async (eventID, payload) => {
        const event_id = String(eventID)
        
        if(idSears){
            serverAddProducts( event_id, payload )
        }else{
            localAddProducts( event_id, payload )
        }
    }
    useEffect(()=>{
        if(respAddProductS){
            setResponseListEvents(respAddProductS)
        }else if(respAddProductL){
            setResponseListEvents(respAddProductL)
        }
    },[ respAddProductS, respAddProductL ])



    // elimina productos con el delete
    const [ respDelete, setRespDelete ] = useState(false)
    const deleteProductEvent = async (eventID, productID, productSKU) => {
        dispatch(showLoader());

        if(idSears){
            serverDeleteProducts( eventID, productID, productSKU )
        }else{
            localDeleteProducts( eventID, productID, productSKU )
        }
    }
    useEffect(()=>{
        if(respDeleteProductS){
            setRespDelete(respDeleteProductS)
        }else if(respDeleteProductL){
            setRespDelete(respDeleteProductL)
        }
    },[ respDeleteProductS, respDeleteProductL ])


    
    // Flujos de hook
    useEffect(()=>{
        const emailUser = String(userProfile?.correo)
        if(addProducts){
            const  {eventID, payload } = addProducts

            dispatch(showLoader());
            if(firstAdd){
                const newPayload = {
                    ...payload,
                    customer_sears_id: idSears,
                    customer_sears_email: emailUser,
                    guest_email: null,
                    guest_phone_number: null
                }
                createCartEvent(eventID, newPayload)
                setAddProducts(false)
                setFirstAdd(false)
            }else{
                addProductEvent(eventID, payload)
                setAddProducts(false)
                setFirstAdd(false)
            }
        }
    },[ addProducts, firstAdd ])

    useEffect(() => {
        if(respDelete){
            const products = listEvents[0]?.products.filter(events => events.product_sears_id !== respDelete?.productID)
            const newResp = [{
                ...listEvents[0],
                products   
            }]
            dispatch(hideLoader());
            if(products?.length > 0){
                setResponseListEvents(newResp)
                setAddProducts(false)
            }else{
                setResponseListEvents([])
                setAddProducts(false)
            }
        }
    },[ respDelete ])

    useEffect(()=>{
        if(responseListEvents && productsList){
            if(responseListEvents?.length >= 1){
                
                const products = responseListEvents[0]?.products.map(prod => {
                    const prodData = productsList.filter(product => (product.id === prod?.product_sears_id || product.variantSelected === prod?.children_sku_sears))
                    const producto = {
                        ...prod,
                        title: prodData[0]?.title,
                        pricing: prodData[0]?.pricing,
                        pictures: prodData[0]?.pictures
                    }
                    return producto
                })

                const response = [{
                    ...responseListEvents[0],
                    products
                }]
                setListEvents(response)

                dispatch(hideLoader());
                setFirstAdd(false)
            }
            else{
                dispatch(hideLoader());
                setListEvents(404)
            }
        }
    },[ responseListEvents, productsList ])

    useEffect(()=>{
        if(listEvents === 404){
            setFirstAdd(true)
        }
        if(listEvents){
            setLastEventsS(listEvents)
            setLastEventsL(listEvents)
        }
    },[ listEvents ])

    return {
        getListCarts,
        listEvents,
        deleteProducts: deleteProductEvent,
        setAddProducts,
        setProductsList
    }
}

export default useCartsUser